import Link from '@eliadmin/core/src/components/link';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export type ChipItem = { id: number; label: string; href?: string };

const TONES = {
  /** Figma „Chip“ State=Default (4403:132): green 200, ink text. */
  green: {
    chip: 'bg-[#b2d6aa] text-[#14171a]',
    link: 'hover:bg-[#7fbc72] focus-visible:ring-[#14171a]',
  },
  /** On dark surfaces (Kde pôsobíme): white text, 16 % white outline. */
  dark: {
    chip: 'border border-white/[0.16] text-white',
    link: 'hover:border-white/50 focus-visible:ring-white',
  },
} as const;

/** Row of chips (Spec text, radius 5/0/5/5, gaps 8 × 10); chips with `href` are links. */
export function ChipList({
  items,
  tone = 'green',
  className,
}: {
  items: ChipItem[];
  tone?: keyof typeof TONES;
  className?: string;
}) {
  if (!items.length) return null;

  const chip = cn(
    'svt-spec inline-flex items-center rounded-[5px] rounded-tr-none px-3 py-1',
    TONES[tone].chip,
  );

  return (
    <ul className={cn('flex flex-wrap gap-x-2 gap-y-2.5', className)}>
      {items.map(item => (
        <li key={item.id} className="flex">
          {item.href ? (
            <Link
              href={item.href}
              prefetch={false}
              className={cn(
                chip,
                'transition-colors focus-visible:outline-none focus-visible:ring-2',
                TONES[tone].link,
              )}
            >
              {item.label}
            </Link>
          ) : (
            <span className={chip}>{item.label}</span>
          )}
        </li>
      ))}
    </ul>
  );
}
